import React from "react";
import { Anchor as AntAnchor } from "antd";
import type { AnchorProps as AntAnchorProps } from "antd";
const { Link } = AntAnchor;
export type AnchorLink = {
  /** The title of the link */
  title: string;
  /** The target of the link (ID or URL) */
  href: string;
  /** Optional child links */
  children?: AnchorLink[];
};
export type AnchorProps = AntAnchorProps & {
  /** Array of links to display */
  links: AnchorLink[];
};
const Anchor: React.FC<AnchorProps> = ({ links, ...props }) => {
  const renderLinks = (links: AnchorLink[]) =>
    links.map((link) => (
      <Link key={link.href} href={link.href} title={link.title}>
        {link.children && renderLinks(link.children)}
      </Link>
    ));
  return <AntAnchor {...props}>{renderLinks(links)}</AntAnchor>;
};
export default Anchor;
